var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"spinner",style:({ borderColor: _vm.color })},'div',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }